import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import "./Resources.css";

const Resources = () => {
  return (
    <main className="resources">
      <Seo
        title="Resources | Clean Sweeps"
        description="Guides for running and managing Shopify sweepstakes, including dropshipping campaigns, storefront widgets, and compliance tips."
        path="/resources"
        image="/og/resources.png"
        imageAlt="Clean Sweeps sweepstakes resources"
      />

      <header className="resources__hero">
        <p className="resources__eyebrow">Resources</p>
        <h1>Sweepstakes guides, checklists, and playbooks.</h1>
        <p className="resources__lead">
          Explore best practices for running sweepstakes, improving engagement,
          and managing Shopify sweepstakes with Clean Sweeps.
        </p>
        <div className="resources__actions">
          <a
            href="https://apps.shopify.com/clean-sweeps"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--primary"
          >
            Install Clean Sweeps
          </a>
          <Link to="/setup" className="btn btn--ghost">
            View setup guides
          </Link>
        </div>
      </header>

      <section className="resources__section">
        <div className="resources__header">
          <h2>Featured guides</h2>
          <p>Start with the highest-impact resources for sweepstakes growth.</p>
        </div>
        <div className="resources__grid">
          <article className="resources__card">
            <h3>API Documentation</h3>
            <p>Build custom entry displays and connect your storefront to Clean Sweeps with GraphQL references and practical examples.</p>
            <Link to="/api-documentation">Explore the API</Link>
          </article>
          <article className="resources__card">
            <h3>How to run a sweepstakes on Shopify</h3>
            <p>
              Step-by-step guidance on planning, launching, and managing
              sweepstakes with a Shopify sweepstakes app.
            </p>
            <Link to="/how-to-run-a-sweepstakes">Read the guide</Link>
          </article>
          <article className="resources__card">
            <h3>Dropshipping sweepstakes playbook</h3>
            <p>
              Low dropshipping sales? Run a sweepstakes to boost engagement,
              referrals, and order volume.
            </p>
            <Link to="/dropshipping-sweepstakes">Open the playbook</Link>
          </article>
        </div>
      </section>

      <section className="resources__section">
        <div className="resources__header">
          <h2>Widget guidance and compliance</h2>
          <p>
            Detailed guides for sweepstakes compliance and storefront entry
            visibility.
          </p>
        </div>
        <div className="resources__grid">
          <article className="resources__card">
            <h3>Sweepstakes compliance checklist</h3>
            <p>
              Review AMOE requirements, official rules, and recordkeeping
              essentials.
            </p>
            <Link to="/sweepstakes-compliance-checklist">View the checklist</Link>
          </article>
          <article className="resources__card">
            <h3>Sweepstakes widgets</h3>
            <p>
              Explore widget settings, requirements, troubleshooting, and where
              to show entries on Shopify for maximum visibility.
            </p>
            <Link to="/sweepstakes-entry-widgets">See widget guidance</Link>
          </article>
        </div>
      </section>

      <section className="resources__section">
        <div className="resources__header">
          <h2>Explore Clean Sweeps</h2>
          <p>
            See how the Clean Sweeps sweepstakes platform manages entries,
            storefront visibility, and winner workflows.
          </p>
        </div>
        <div className="resources__grid">
          <article className="resources__card">
            <h3>What we do</h3>
            <p>Get a full breakdown of entry rules, widgets, and compliance.</p>
            <Link to="/what-we-do">Explore features</Link>
          </article>
          <article className="resources__card">
            <h3>Setup guides</h3>
            <p>Implementation tips for entry rules, widgets, and referrals.</p>
            <Link to="/setup">View setup guides</Link>
          </article>
          <article className="resources__card">
            <h3>Consulting</h3>
            <p>Need a hand? Get strategy support for your next sweepstakes.</p>
            <Link to="/consulting">Request consulting</Link>
          </article>
        </div>
      </section>
    </main>
  );
};

export default Resources;
